// extracted by mini-css-extract-plugin
export default {"pickerContainer":"CommentMenu-module__pickerContainer--sLexl","backdrop":"CommentMenu-module__backdrop--OZeAa"};